<template>
  <div class="content">


    <div style="text-align: center;display:flex;align-items: center;width: 100%;"
         :style="{'height': loaderHeight + 'px'}" v-if="isLoading">
      <div style="margin:0 auto">
        <mu-circular-progress></mu-circular-progress>
        <br/>
        <div style="height: 16px;"></div>
        {{$t('message.loadingText')}}
      </div>
    </div>

    <mu-row v-if="data.recipes" gutter>
      <mu-col class="bottom" width="100" desktop="33" tablet="33" v-for="recipe, index in data.recipes"
              :key="'r' + index">
        <recipe-card :recipe="recipe"></recipe-card>
      </mu-col>
    </mu-row>

    <div ref="detector"></div>

    <div style="text-align: center;" v-if="isAppending">
      <div>
        {{$t('message.loadingText')}}
        <div style="height: 16px;"></div>
        <mu-circular-progress></mu-circular-progress>
      </div>
    </div>


  </div>
</template>

<script>
  import RecipeApi from '../../api/Recipes'
  import AccountApi from '../../api/Account'

  import RecipeCard from "./Components/RecipeCard";
  import ScrollManager from '../../helpers/ScrollManager'
  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";

  export default {
    components: {
      MuCircularProgress,
      RecipeCard
    },
    name: "RecipeCategory",
    data() {
      return {
        loaderHeight: 0,
        isAppending: false,
        isLoading: true,
        query: {
          page: 0
        },
        lastResponse: [],
        data: {
          recipes: [],
          paginationInfo: {}
        }
      }
    },
    mounted() {
      let self = this;
      self.addScrollListener();


      AccountApi.getUserPersonalization()
        .then(function (response) {
          self.dietaryPreferenceId = response.data.dietry_preference_id;

          self.loaderHeight = $('.main-content').outerHeight();
          let category = self.$route.query;
          if (category.grouping === 'dietaryTypes') {
            self.query = {
              page: 0,
              limit: 15,
              dietaryTypes: category.route
            }
          }

          if (category.grouping === 'favorites') {
            self.query = {
              page: 0,
              limit: 15,
              search: category.route,
              dietaryTypes: self.dietaryTypesList().join(',')
            }
          }

          if (category.grouping === 'categories') {
            self.query = {
              page: 0,
              limit: 15,
              categories: category.route,
              dietaryTypes: self.dietaryTypesList().join(',')
            }
          }

          if (category.grouping === 'seasonal') {
            self.query = {
              page: 0,
              limit: 15,
              seasonal: category.route,
              dietaryTypes: self.dietaryTypesList().join(',')
            }
          }

          if (category.grouping === 'allergies') {
            self.query = {
              page: 0,
              limit: 500,
              suitabilities: category.route,
              dietaryTypes: self.dietaryTypesList().join(',')
            }
          }

          if (category.grouping !== 'allergies') {
            RecipeApi.search(self.query).then((response) => {
              self.data = response.data;
              self.lastResponse = response.data.recipes;
              self.$nextTick(function () {
                self.isLoading = false;
              });
            });
          }
          else {
            RecipeApi.notingroupQuery(self.query)
              .then(function (response) {
                self.data.recipes = response.data;
                self.lastResponse = response.data.recipes;
                self.$nextTick(function () {
                  self.isLoading = false;
                })
              })
          }
        });
    },
    methods: {
      dietaryTypesList() {
        let self = this;
        switch (self.dietaryPreferenceId) {
          case 1:
            return [
              'Gluten-free',
              'Iron rich',
              'Ketogenic',
              'Low GI',
              'Organic',
              'Paleolithic',
              'Pescetarian',
              'Raw Foods',
              'Vegan',
              'Vegetarian'
            ];
          case 2:
            return [
              'Pescetarian'
            ];
          case 3:
            return [
              'Vegetarian'
            ];
          case 4:
            return [
              'Vegan'
            ];
          default:
            return [
              'Gluten-free',
              'Iron rich',
              'Ketogenic',
              'Low GI',
              'Organic',
              'Paleolithic',
              'Pescetarian',
              'Raw Foods',
              'Vegan',
              'Vegetarian'
            ];
        }
      },
      loadMoreData() {
        let self = this;
        let category = self.$route.query;
        if (category.grouping === 'allergies') {

        }
        else {
          if (self.lastResponse.length !== 0) {
            self.query.page++;
            self.isAppending = true;
            self.$nextTick(function () {
              RecipeApi.search(self.query)
                .then(function (response) {
                  self.lastResponse = response.data.recipes;
                  self.data.recipes.push.apply(self.data.recipes, response.data.recipes);
                  self.data.paginationInfo = response.data.paginationInfo;
                  self.$nextTick(function () {
                    self.isAppending = false;
                  })
                })
            })
          }
          else {
            self.isAppending = false;
          }
        }

      },
      addScrollListener() {
        //add infinite scroll listener
        let self = this;
        let element = document.getElementsByClassName('main-content')[0];
        element.addEventListener('scroll', self.handleScroll);
      },
      handleScroll() {
        let self = this;
        if (ScrollManager.isElementInViewport(self.$refs['detector'])) {
          if (self.isAppending === false) {
            self.loadMoreData();
          }
        }
      }
    },
    beforeDestroy() {
      //remove event listener to stop event bubbling
      let self = this;
      let element = document.getElementsByClassName('main-content')[0];
      element.removeEventListener('scroll', self.handleScroll);
    }
  }
</script>



// WEBPACK FOOTER //
// Category.vue?3485635d